import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './AccueilNew.css';

const AccueilNew = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: '',
    email: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Message envoyé avec succès !');
  };

  return (
    <>
      <Helmet>
        <title>Services de dépannage informatique professionnels à Nantes</title>
        <meta name="description" content="Dépannage informatique professionnel à Nantes. Maintenance, installation, formation. Diagnostic gratuit et frais de déplacement offerts. Contactez-nous au 06 37 58 74 29" />
        <meta name="keywords" content="dépannage informatique, Nantes, maintenance, installation, formation, diagnostic gratuit, Maxence Huret" />
      </Helmet>
      
      <div className="page-content">
        <div className="container">
          {/* Services Section */}
          <section id="prestations" className="services-section">
            <h1>Services de dépannage informatique professionnels à Nantes</h1>
            
            <div className="services-intro">
              <p>
                Votre <strong><Link to="/ordinateur/">ordinateur présente des dysfonctionnements</Link></strong> ? 
                Un logiciel malveillant compromet votre système ? Votre navigateur affiche une page d'accueil inconnue ?<br/>
                Votre périphérique d'impression ne répond plus ? Votre connexion internet est défaillante ?
              </p>
            </div>

            <div className="services-list">
              <ul>
                <li>Maintenance approfondie de votre système informatique</li>
                <li>Dépannage complet Windows, restauration système et fichiers corrompus</li>
                <li>Optimisation et maintenance préventive Windows</li>
                <li>Élimination des programmes malveillants</li>
                <li>Désinstallation des logiciels publicitaires invasifs</li>
                <li>Résolution des problèmes de connectivité et <strong><Link to="/accueil/domicile/">assistance technique</Link></strong></li>
                <li>Configuration et dépannage des périphériques multifonctions</li>
              </ul>
            </div>
          </section>

          {/* Installation Section */}
          <section id="installation" className="installation-section">
            <h2>Services d'installation informatique sur Nantes</h2>
            
            <div className="installation-content">
              <p><strong>Vous envisagez l'acquisition de nouveau matériel ?</strong> Je prends en charge l'intégralité de l'installation, en respectant vos exigences et préférences personnelles.</p>
              
              <div className="installation-details">
                <div className="installation-category">
                  <p><strong>Configuration système :</strong></p>
                  <ul>
                    <li>Déploiement Windows 10 et versions précédentes</li>
                    <li>Configuration environnement Linux</li>
                    <li>Installation applications et utilitaires spécifiques</li>
                  </ul>
                </div>
                
                <div className="installation-category">
                  <p><strong>Installation équipements :</strong></p>
                  <ul>
                    <li>Périphériques d'impression</li>
                    <li>Dispositifs d'affichage</li>
                    <li>Accessoires informatiques</li>
                    <li>Équipements réseau et multimédia</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Formation Section */}
          <section id="formation" className="formation-section">
            <h2>Accompagnement et formation informatique à Nantes</h2>
            
            <div className="formation-content">
              <p><strong>Formation personnalisée à votre domicile,</strong> permettant une maîtrise optimale et rapide de vos équipements informatiques.</p>
              
              <ul>
                <li>Apprentissage environnement Windows</li>
                <li>Maîtrise des outils internet</li>
                <li>Gestion messagerie électronique</li>
                <li>Utilisation applications multimédia</li>
              </ul>
            </div>
          </section>

          {/* Tarifs Section */}
          <section id="tarifs" className="tarifs-section">
            <h2>Grille tarifaire détaillée</h2>
            
            <div className="tarifs-grid">
              <div className="tarif-card">
                <div className="tarif-duration">30 minutes</div>
                <div className="tarif-price">24 €</div>
                <div className="tarif-description">
                  <p>Durée estimée pour :</p>
                  <p>Configuration périphérique</p>
                  <p>Réinitialisation mot de passe</p>
                </div>
                <div className="tarif-note">Déplacement Inclus</div>
              </div>

              <div className="tarif-card">
                <div className="tarif-duration">1 heure</div>
                <div className="tarif-price">39 €</div>
                <div className="tarif-description">
                  <p>Durée estimée pour :</p>
                  <p>Configuration Box Internet</p>
                  <p>Élimination logiciels publicitaires</p>
                </div>
                <div className="tarif-note">Déplacement Inclus</div>
              </div>

              <div className="tarif-card">
                <div className="tarif-duration">1 heure 30</div>
                <div className="tarif-price">59 €</div>
                <div className="tarif-description">
                  <p>Durée estimée pour :</p>
                  <p>Optimisation performances</p>
                  <p>Désinfection malwares</p>
                </div>
                <div className="tarif-note">Déplacement Inclus</div>
              </div>

              <div className="tarif-card">
                <div className="tarif-duration">2 heures</div>
                <div className="tarif-price">79 €</div>
                <div className="tarif-description">
                  <p>Durée estimée pour :</p>
                  <p>Installation complète système Windows</p>
                  <p>Configuration environnement</p>
                </div>
                <div className="tarif-note">Déplacement Inclus</div>
              </div>

              <div className="tarif-card">
                <div className="tarif-duration">demi heure supp.</div>
                <div className="tarif-price">19 €</div>
                <div className="tarif-description">
                  <p>Pour interventions complexes dépassant le forfait 2 heures ou nécessitant un temps additionnel.</p>
                </div>
                <div className="tarif-note">Déplacement Inclus</div>
              </div>
            </div>

            <div className="devis-section">
              <p>Pour toute demande spécifique :</p>
              <a href="#contact" className="btn btn-primary">Sollicitez un devis personnalisé gratuit</a>
            </div>
          </section>

          {/* Contact Info */}
          <section className="contact-info-section">
            <div className="contact-highlights">
              <p>Bénéficiez d'un diagnostic gratuit.</p>
              <p>Frais de déplacement offerts.</p>
              <p><a href="tel:0637587429" className="phone-link">06 37 58 74 29</a></p>
            </div>
          </section>

          {/* Contact Form */}
          <section id="contact" className="contact-form-section">
            <form onSubmit={handleSubmit} className="contact-form">
              <fieldset>
                <p>
                  <label htmlFor="name">Nom <abbr title="requis">*</abbr></label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name" 
                    value={formData.name}
                    onChange={handleInputChange}
                    required 
                  />
                </p>
                
                <p>
                  <label htmlFor="phone">Téléphone <abbr title="requis">*</abbr></label>
                  <input 
                    type="tel" 
                    id="phone" 
                    name="phone" 
                    value={formData.phone}
                    onChange={handleInputChange}
                    required 
                  />
                </p>
                
                <p>
                  <label htmlFor="message">Message <abbr title="requis">*</abbr></label>
                  <textarea 
                    id="message" 
                    name="message" 
                    rows="7" 
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                  ></textarea>
                </p>
                
                <p>
                  <label htmlFor="email">Email</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </p>
                
                <p>
                  <input type="submit" value="Valider" className="btn btn-primary" />
                </p>
              </fieldset>
            </form>
          </section>

          {/* Additional Info */}
          <section className="additional-info-section">
            <h2>Besoin d'accompagnement pour sélectionner et configurer votre équipement informatique ? Urgence technique ? Contactez Mon Dépannage Informatique à Nantes.</h2>
            
            <p>
              Expert en solutions informatiques et maintenance préventive, notre service est disponible sur l'ensemble de l'agglomération nantaise. 
              Fort d'une expertise pluriannuelle en services numériques, nous intervenons pour tout type d'assistance technique et bureautique. 
              Votre infrastructure informatique rencontre des difficultés techniques nécessitant une intervention urgente ? En tant que professionnel qualifié, 
              nous vous accompagnons dans la récupération de vos données critiques. Nos interventions à domicile couvrent notamment l'installation et la configuration de solutions antivirus.
            </p>
            
            <p>
              Nous proposons également des formations personnalisées pour une prise en main efficace de vos outils numériques. La cybersécurité représente 
              aujourd'hui un enjeu crucial pour la protection de votre environnement informatique. Notre expertise en dépannage nous permet d'établir un 
              diagnostic précis avant toute intervention. Pour les défaillances matérielles majeures, nous vous informons systématiquement avant d'entreprendre 
              les réparations nécessaires. Notre entreprise de services à la personne se concentre exclusivement sur la maintenance et le dépannage, excluant la création web. 
              La sécurisation des données constitue un aspect fondamental pour votre activité professionnelle.
            </p>
            
            <p>
              Établis à Nantes, nous couvrons l'intégralité de la métropole. Pour plus d'informations, notre équipe reste joignable par téléphone. 
              Support technique à distance : après un premier contact, nous établissons une connexion sécurisée pour résoudre vos problématiques. 
              Intervention sur site : pour les situations urgentes, nous garantissons une réactivité optimale sur rendez-vous.
            </p>
            
            <h3>Solutions rapides et efficaces pour tout dysfonctionnement informatique.</h3>
            
            <p>
              Avantages : prise en charge globale de votre infrastructure permettant de vous concentrer sur votre cœur d'activité. Notre expertise est votre garantie. 
              Besoin d'assistance pour l'assemblage ou l'évolution de votre configuration ? Votre système présente des ralentissements inexpliqués ?
            </p>
            
            <p>
              Mon Dépannage Informatique propose des services d'assistance technique à domicile sur Nantes et la Loire-Atlantique. Maxence Huret met son expertise 
              au service de vos besoins en installation et <strong><Link to="/accueil/domicile/">réparation informatique</Link></strong> : récupération de données, 
              réinstallation système, intégration composants (cartes réseau, graphiques...), optimisation stockage (SSD, HDD, RAM) avec sauvegarde sécurisée, 
              résolution des problèmes de performance. Contactez-nous pour une intervention rapide à Nantes.
            </p>
            
            <h3>Programmes de formation personnalisés en informatique.</h3>
            
            <p>
              Notre service de télémaintenance permet une assistance technique à distance efficace. Cette solution s'avère particulièrement adaptée pour certaines 
              interventions ne nécessitant pas de présence physique. Pour chaque problématique, bénéficiez de l'expertise d'un professionnel qualifié sur Nantes et sa périphérie.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default AccueilNew;
